import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import { SizeLimitInKbToSuggestSharing } from '../utils/filePickerConstants';
import { isImageFile } from 'owa-file';
import { format } from 'owa-strings';
import FilePickerActionMessageType, {
    actionMessageMap,
} from '../types/FilePickerActionMessageType';

export interface DisableActionWithMessage {
    shouldDisable: boolean;
    message?: string;
}

export function shouldDisableAttachButton(
    selectedItems: FileProviderItemViewState[] | File[],
    fileProviderName: string,
    maxTotalFileSizeInBytes?: number
): DisableActionWithMessage {
    if (selectedItems === null || selectedItems.length === 0) {
        return {
            shouldDisable: true,
            message: null,
        };
    }

    if (!maxTotalFileSizeInBytes) {
        return {
            shouldDisable: false,
            message: null,
        };
    }

    // We need to check the size of the selected items to know if they don't exceed the max size
    let totalFileSizeInBytes = 0;
    if ((<FileProviderItemViewState>selectedItems[0]).model) {
        totalFileSizeInBytes = (selectedItems as FileProviderItemViewState[]).reduce(
            (totalSize, item) => totalSize + item.model.Size,
            0
        );
    } else {
        totalFileSizeInBytes = (selectedItems as File[]).reduce(
            (totalSize, item) => totalSize + item.size,
            0
        );
    }

    if (totalFileSizeInBytes > maxTotalFileSizeInBytes) {
        const maxTotalFileSizeInMB = Math.ceil(maxTotalFileSizeInBytes / (1024 * 1024));
        return {
            shouldDisable: true,
            message:
                selectedItems.length > 1
                    ? format(
                          actionMessageMap[FilePickerActionMessageType.MultipleFilesTooLarge](),
                          maxTotalFileSizeInMB,
                          fileProviderName
                      )
                    : format(
                          actionMessageMap[FilePickerActionMessageType.SingleFileTooLarge](),
                          maxTotalFileSizeInMB,
                          fileProviderName
                      ),
        };
    } else if (totalFileSizeInBytes > SizeLimitInKbToSuggestSharing * 1024) {
        const totalFileSizeInMB = Math.ceil(totalFileSizeInBytes / 1024 / 1024);
        return {
            shouldDisable: false,
            message:
                selectedItems.length > 1
                    ? format(
                          actionMessageMap[
                              FilePickerActionMessageType.MultipleFilesSuggestSharing
                          ](),
                          totalFileSizeInMB,
                          fileProviderName
                      )
                    : format(
                          actionMessageMap[FilePickerActionMessageType.SingleFileSuggestSharing](),
                          totalFileSizeInMB,
                          fileProviderName
                      ),
        };
    }

    return {
        shouldDisable: false,
        message: null,
    };
}

export function shouldDisableShareButton(
    selectedItems: FileProviderItemViewState[] | File[]
): boolean {
    if (selectedItems === null || selectedItems.length === 0) {
        return true;
    }

    return false;
}

export function shouldAllowInsertAction(selectedFiles: File[]): boolean {
    return selectedFiles.every(file => isImageFile(file.name));
}
